import Cookies from "js-cookie";
import { Navigate, useNavigate } from "react-router-dom";
import Header from "../header/header";
import Sidebar from "../sidebar/sidebar";
import Footer from "../footer/footer";
import { LOGOUT_URL } from "../../global/API";

const ProtectedRoute = ({ children }) => {
  const jwtToken = Cookies.get("jwtToken");
  const navigate = useNavigate();

  const onLogout = async () => {
    const URL = LOGOUT_URL;
    try {
      const options = {
        method: "POST",
        headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
      };
      const response = await fetch(URL, options);
      const data = await response.json();
      Cookies.remove("jwtToken");
      navigate("/signin", { replace: true });
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  if (jwtToken === undefined) {
    return <Navigate to="/signin" replace />;
  } else {
    return (
      <>
        <Header onLogout={onLogout} />
        <Sidebar onLogout={onLogout} />
        {children}
        <Footer />
      </>
    );
  }
};
export default ProtectedRoute;
